import React from 'react';
import { gql, useQuery } from '@apollo/client';

// Components
import { UpcomingAssessmentSessionsContainer } from './upcoming-assessment-sessions.container';

// Data
import { ASSESSMENT_SESSION_FIELDS } from '../../../lib/queries/assessment-session.queries';
import { AGE_GROUP_FIELDS } from '../../../lib/queries/age-group.queries';
import { getAuthUser } from '../../../lib/services/auth.service';
import { useActiveAgeGroupIdsInAssessment } from '../../../lib/services/age-group.service';

const GET_UPCOMING_ASSESSMENT_SESSIONS = gql`
  query GetUpcomingAssessmentSessions($assessmentId: ID!, $ageGroupIds: [ID!]!) {
    assessmentSessions(assessmentId: $assessmentId, ageGroupIds: $ageGroupIds) {
      ...AssessmentSessionFields
      ageGroup {
        ...AgeGroupFields
        bucket
      }
      playerCount
      drillCount
      practicePlanCount
    }
  }

  ${ASSESSMENT_SESSION_FIELDS}
  ${AGE_GROUP_FIELDS}
`;

export const UpcomingAssessmentSessionsGraphQL = () => {
  const user = getAuthUser();
  const { ageGroupIds, loading: ageGroupIdsLoading, error: ageGroupIdsError } = useActiveAgeGroupIdsInAssessment();

  const { data, loading, error } = useQuery(GET_UPCOMING_ASSESSMENT_SESSIONS, {
    variables: { assessmentId: user?.settings?.activeAssessmentId, ageGroupIds },
    skip: !user?.settings?.activeAssessmentId || !ageGroupIds,
    fetchPolicy: 'cache-and-network'
  });

  const assessmentSessions = (data && data.assessmentSessions) || [];

  return <UpcomingAssessmentSessionsContainer
    assessmentSessions={assessmentSessions}
    loading={ageGroupIdsLoading || loading}
    fetchError={Boolean(ageGroupIdsError) || Boolean(error)}
  />;
};
